/* Product page: gallery, variant switching via the Section Rendering API,
   add to cart, bulk variant table, developer cross-sell, sticky bar.
   Without this file the plain product form and gallery links still work. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_product']) return;
  window.__hwsLoaded['component_product'] = true;

  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};

  /* ------------------------------------------------------------- gallery */
  /* Verse koopkolom ophalen via de Section Rendering API. Staat los van de
     variantkiezer zodat ook de tintkiezer (kleuringstemplate) hem kan
     aanroepen — daar bestaat de variantkiezer namelijk niet. */
  function refreshBuyColumn(baseUrl, sectionId, variant) {
    if (!baseUrl || !sectionId || !variant || !variant.id) return;
    var url = baseUrl + '?variant=' + variant.id + '&section_id=' + sectionId;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var parsed = new DOMParser().parseFromString(text, 'text/html');
      /* Alleen binnen de koopkolom en de plakbalk verversen. Eerder ging dit over
         de hele pagina, waardoor ook de bezorg- en voorraadregels in de aanbevolen
         productkaarten werden overschreven met de versie van de productpagina —
         vandaar twee groene stippen onder elkaar in die kaartjes. */
      var vlakken = [];
      document.querySelectorAll('.main-product__info, [data-product-sticky-bar]').forEach(function (el) {
        vlakken.push(el);
      });
      if (!vlakken.length) vlakken.push(document);
      var zoekAlles = function (selector) {
        var gevonden = [];
        vlakken.forEach(function (vlak) {
          vlak.querySelectorAll(selector).forEach(function (el) {
            if (gevonden.indexOf(el) === -1) gevonden.push(el);
          });
        });
        return gevonden;
      };
      [
        ['[data-price-wrapper]', true],
        ['[data-variant-sku]', false],
        ['[data-variant-barcode]', false],
        ['[data-variant-title]', false],
        ['[data-stock-status]', true],
        ['[data-delivery-time]', true],
        ['[data-sticky-price]', false]
      ].forEach(function (pair) {
        var source = parsed.querySelector('.main-product__info ' + pair[0]) || parsed.querySelector(pair[0]);
        zoekAlles(pair[0]).forEach(function (target) {
          if (!source) { target.hidden = true; return; }
          target.hidden = false;
          if (pair[1]) { target.outerHTML = source.outerHTML; } else { target.textContent = source.textContent; }
        });
      });
      /* De vervangen regels hebben hun bezorgbelofte opnieuw nodig. */
      if (window.hwsDeliveryPromise) window.hwsDeliveryPromise();
      [['[data-add-to-cart]', '[data-add-to-cart-text]'], ['[data-sticky-add]', '[data-sticky-add-text]']]
        .forEach(function (pair) {
          var button = document.querySelector(pair[0]);
          var fresh = parsed.querySelector(pair[0]);
          if (!button || !fresh) return;
          button.disabled = fresh.hasAttribute('disabled');
          var t = button.querySelector(pair[1]);
          var nt = fresh.querySelector(pair[1]);
          if (t && nt) t.textContent = nt.textContent.trim();
        });
    }).catch(function () { /* netwerkfout: de pagina blijft staan zoals hij was */ });
  }

  /* De tintkiezer stuurt hetzelfde event maar heeft geen eigen refresh. */
  document.addEventListener('hws:variant:change', function (event) {
    var d = event.detail || {};
    if (d.source === 'variant-picker') return;
    var v = d.variant;
    if (!v || !v.url) return;
    refreshBuyColumn(v.url.split('?')[0], d.sectionId, v);
  });

  class HwsProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      if (!this.slides.length) return;
      this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      var self = this;
      this.thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { self.showMedia(thumb.getAttribute('data-gallery-thumb')); });
      });
      var prev = this.querySelector('[data-gallery-prev]');
      var next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { self.step(-1); });
      if (next) next.addEventListener('click', function () { self.step(1); });

      /* De vergrootknop is een gewone link naar het beeldbestand, zodat hij ook
         zonder JavaScript werkt. Met JavaScript openen we in plaats daarvan de
         vergrootweergave in het thema — anders belandt de bezoeker op een losse
         afbeelding bij de beeldopslag en moet hij terug. */
      var zoom = this.querySelector('[data-gallery-zoom]');
      if (zoom) {
        zoom.addEventListener('click', function (event) {
          event.preventDefault();
          self.openZoom();
        });
      }
      /* Op de foto zelf tikken doet hetzelfde; dat is wat mensen verwachten. */
      this.querySelectorAll('[data-gallery-slide] img').forEach(function (img) {
        img.addEventListener('click', function () {
          if (self.querySelector('[data-gallery-zoom]')) self.openZoom();
        });
      });

      /* Vegen tussen de foto's op een telefoon. */
      var startX = null;
      var startY = null;
      var stage = this.querySelector('[data-gallery-viewport]') || this;
      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var eind = event.changedTouches[0];
        var dx = eind.clientX - startX;
        var dy = eind.clientY - startY;
        startX = null;
        startY = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        self.step(dx < 0 ? 1 : -1);
      }, { passive: true });
      document.addEventListener('hws:variant:change', function (event) {
        var v = event.detail && event.detail.variant;
        if (v && v.featured_media_id) self.showMedia(v.featured_media_id);
      });
    }
    step(dir) {
      var next = this.index + dir;
      if (next < 0) next = this.slides.length - 1;
      if (next >= this.slides.length) next = 0;
      this.show(next);
    }
    showMedia(id) {
      var i = this.slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(id); });
      if (i >= 0) this.show(i);
    }
    show(i) {
      this.index = i;
      this.slides.forEach(function (slide, n) {
        var active = n === i;
        slide.classList.toggle('is-active', active);
        if (active) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
      });
      var id = this.slides[i].getAttribute('data-media-id');
      this.thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', String(thumb.getAttribute('data-gallery-thumb')) === String(id));
      });
      var zoom = this.querySelector('[data-gallery-zoom]');
      var img = this.slides[i].querySelector('img');
      if (zoom && img) zoom.setAttribute('href', img.currentSrc || img.src);
      if (this.zoomLaag && !this.zoomLaag.hidden) this.vulZoom();
    }

    /* Vergrootweergave: de foto groot op een donkere laag, met de pijlen en de
       duimnagels erbij. Op een telefoon kun je erin knijpen (pinch) omdat de
       foto in een eigen schuifvlak staat. */
    openZoom() {
      if (!this.zoomLaag) this.bouwZoom();
      this.vulZoom();
      this.zoomLaag.hidden = false;
      document.documentElement.classList.add('hws-scroll-lock');
      var sluit = this.zoomLaag.querySelector('[data-zoom-close]');
      if (sluit) sluit.focus();
    }

    sluitZoom() {
      if (!this.zoomLaag) return;
      this.zoomLaag.hidden = true;
      document.documentElement.classList.remove('hws-scroll-lock');
      var knop = this.querySelector('[data-gallery-zoom]');
      if (knop) knop.focus();
    }

    bouwZoom() {
      var self = this;
      var strings = window.hwsStrings || {};
      var laag = document.createElement('div');
      laag.className = 'product-zoom';
      laag.hidden = true;
      laag.setAttribute('role', 'dialog');
      laag.setAttribute('aria-modal', 'true');
      laag.innerHTML =
        '<button type="button" class="icon-btn product-zoom__close" data-zoom-close aria-label="' +
        (strings.close || 'Sluiten') +
        '"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><use href="#hws-icon-close"></use></svg></button>' +
        '<button type="button" class="icon-btn product-zoom__nav product-zoom__nav--prev" data-zoom-prev aria-label="' +
        (strings.previous || 'Vorige') +
        '"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><use href="#hws-icon-chevron-left"></use></svg></button>' +
        '<button type="button" class="icon-btn product-zoom__nav product-zoom__nav--next" data-zoom-next aria-label="' +
        (strings.next || 'Volgende') +
        '"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><use href="#hws-icon-chevron-right"></use></svg></button>' +
        '<div class="product-zoom__stage" data-zoom-stage></div>' +
        '<p class="product-zoom__count" data-zoom-count></p>';
      document.body.appendChild(laag);
      this.zoomLaag = laag;

      laag.addEventListener('click', function (event) {
        if (event.target.closest('[data-zoom-close]')) { self.sluitZoom(); return; }
        if (event.target.closest('[data-zoom-prev]')) { self.step(-1); return; }
        if (event.target.closest('[data-zoom-next]')) { self.step(1); return; }
        /* Naast de foto tikken sluit ook. */
        if (!event.target.closest('img') && !event.target.closest('.icon-btn')) self.sluitZoom();
      });
      document.addEventListener('keydown', function (event) {
        if (laag.hidden) return;
        if (event.key === 'Escape') self.sluitZoom();
        if (event.key === 'ArrowRight') self.step(1);
        if (event.key === 'ArrowLeft') self.step(-1);
      });
      var sx = null;
      laag.addEventListener('touchstart', function (event) {
        sx = event.touches.length === 1 ? event.touches[0].clientX : null;
      }, { passive: true });
      laag.addEventListener('touchend', function (event) {
        if (sx === null) return;
        var dx = event.changedTouches[0].clientX - sx;
        sx = null;
        if (Math.abs(dx) < 50) return;
        self.step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    vulZoom() {
      var vlak = this.zoomLaag.querySelector('[data-zoom-stage]');
      var teller = this.zoomLaag.querySelector('[data-zoom-count]');
      var bron = this.slides[this.index].querySelector('img');
      if (!vlak || !bron) return;
      /* Dezelfde bron, maar op volle breedte opgevraagd. */
      var url = (bron.currentSrc || bron.src || '').replace(/([?&])width=\d+/, '$1width=2400');
      vlak.innerHTML = '';
      var groot = document.createElement('img');
      groot.className = 'product-zoom__image';
      groot.src = url;
      groot.alt = bron.alt || '';
      vlak.appendChild(groot);
      if (teller) {
        teller.textContent = this.slides.length > 1
          ? this.index + 1 + ' / ' + this.slides.length
          : '';
      }
      var meer = this.slides.length > 1;
      this.zoomLaag.querySelectorAll('.product-zoom__nav').forEach(function (b) { b.hidden = !meer; });
    }
  }
  if (!customElements.get('hws-product-gallery')) customElements.define('hws-product-gallery', HwsProductGallery);

  /* ------------------------------------------------------ variant picker */
  class HwsVariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = this.readData();
      if (!this.variants.length) return;
      this.form = document.getElementById(this.dataset.form);
      this.addEventListener('change', this.onChange.bind(this));
      this.sync(this.currentVariant(), true);
    }
    readData() {
      var s = this.querySelector('[data-variant-data]');
      if (!s) return [];
      try { return JSON.parse(s.textContent); } catch (e) { return []; }
    }
    selectedOptions() {
      var values = [];
      this.querySelectorAll('[data-option-position]').forEach(function (el) {
        if (el.tagName === 'SELECT') { values[Number(el.getAttribute('data-option-position')) - 1] = el.value; return; }
        if (el.checked) values[Number(el.getAttribute('data-option-position')) - 1] = el.value;
      });
      return values;
    }
    currentVariant() {
      var chosen = this.selectedOptions();
      var found = this.variants.filter(function (v) {
        return v.options.every(function (o, i) { return !chosen[i] || chosen[i] === o; });
      })[0];
      return found || this.variants[0];
    }
    onChange() {
      var variant = this.currentVariant();
      this.sync(variant, false);
    }
    sync(variant, silent) {
      if (!variant) return;
      if (this.form) {
        var input = this.form.querySelector('input[name="id"]');
        if (input) { input.value = variant.id; input.disabled = !variant.available; }
      }
      document.querySelectorAll('form[id^="DynamicForm"] input[name="id"]').forEach(function (el) { el.value = variant.id; });
      if (silent) return;
      if (this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }
      document.dispatchEvent(new CustomEvent('hws:variant:change', {
        detail: { variant: variant, sectionId: this.dataset.section, source: 'variant-picker' }
      }));
      this.refreshSection(variant);
    }
    refreshSection(variant) {
      refreshBuyColumn(this.dataset.url, this.dataset.section, variant);
    }
  }
  if (!customElements.get('hws-variant-picker')) customElements.define('hws-variant-picker', HwsVariantPicker);

  /* -------------------------------------------------------- add to cart */
  function submitForm(form, button) {
    var errorEl = document.querySelector('[data-product-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (button) { button.classList.add('btn--loading'); button.setAttribute('aria-busy', 'true'); }
    var data = new FormData(form);
    var items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }];
    var props = {};
    data.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) props[m[1]] = value;
    });
    if (Object.keys(props).length) items[0].properties = props;
    var sellingPlan = data.get('selling_plan');
    if (sellingPlan) items[0].selling_plan = Number(sellingPlan);
    return window.hwsCart.add(items).then(function (res) {
      if (res.__error || res.status) {
        var message = res.description || res.message || strings.cartError;
        if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
        if (window.hwsAnnounce) window.hwsAnnounce(message);
        return;
      }
      window.hwsCart.renderSections(res);
      window.hwsCart.fetchState().then(function (state) { window.hwsCart.syncCount(state); });
      if (config.cartType === 'drawer' && document.getElementById('CartDrawer')) {
        window.hwsOverlay.open('CartDrawer');
      } else {
        window.hwsToast.show(strings.addedToCart);
      }
    }).catch(function () {
      if (errorEl) { errorEl.textContent = strings.cartError; errorEl.hidden = false; }
    }).finally(function () {
      if (button) { button.classList.remove('btn--loading'); button.removeAttribute('aria-busy'); }
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch || !window.hwsCart) return;
    event.preventDefault();
    submitForm(form, document.querySelector('[data-add-to-cart]'));
  });

  /* ------------------------------------------------- bulk variant table */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-variant-bulk-submit]');
    if (button) {
      event.preventDefault();
      var wrap = button.closest('.variant-bulk');
      var items = [];
      wrap.querySelectorAll('[data-bulk-variant]').forEach(function (row) {
        var input = row.querySelector('.quantity__input');
        var qty = input ? parseInt(input.value, 10) || 0 : 0;
        if (qty > 0) items.push({ id: Number(row.getAttribute('data-bulk-variant')), quantity: qty });
      });
      var errorEl = wrap.querySelector('[data-variant-bulk-error]');
      if (!items.length) {
        if (errorEl) { errorEl.textContent = strings.chooseVariant || ''; errorEl.hidden = false; }
        return;
      }
      if (errorEl) errorEl.hidden = true;
      button.classList.add('btn--loading');
      window.hwsCart.add(items).then(function (res) {
        if (res.__error || res.status) {
          if (errorEl) { errorEl.textContent = res.description || strings.cartError; errorEl.hidden = false; }
          return;
        }
        wrap.querySelectorAll('.quantity__input').forEach(function (i) { i.value = 0; });
        window.hwsCart.renderSections(res);
        window.hwsCart.fetchState().then(function (s) { window.hwsCart.syncCount(s); });
        if (config.cartType === 'drawer' && document.getElementById('CartDrawer')) {
          window.hwsOverlay.open('CartDrawer');
        } else { window.hwsToast.show(strings.addedToCart); }
      }).finally(function () { button.classList.remove('btn--loading'); });
      return;
    }

    var dev = event.target.closest('[data-developer-add]');
    if (dev) {
      event.preventDefault();
      dev.setAttribute('aria-busy', 'true');
      window.hwsCart.add([{ id: Number(dev.getAttribute('data-developer-add')), quantity: 1 }]).then(function (res) {
        if (res.__error || res.status) return;
        window.hwsCart.renderSections(res);
        window.hwsCart.fetchState().then(function (s) { window.hwsCart.syncCount(s); });
        window.hwsToast.show(strings.addedToCart);
      }).finally(function () { dev.removeAttribute('aria-busy'); });
    }
  });

  /* ------------------------------------------------------- sticky bar */
  function stickyBar() {
    var bar = document.querySelector('[data-product-sticky-bar]');
    var anchor = document.querySelector('[data-add-to-cart]');
    if (!bar || !anchor) return;
    function onScroll() {
      var rect = anchor.getBoundingClientRect();
      bar.hidden = rect.bottom > 0;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------- shipping cut-off timer */
  class HwsShippingTimer extends HTMLElement {
    connectedCallback() {
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
      this.cutoffMinute = parseInt(this.dataset.cutoffMinute, 10) || 0;
      this.fromHour = parseInt(this.dataset.fromHour, 10) || 0;
      this.days = (this.dataset.days || '').split(',').filter(Boolean).map(Number);
      this.countdown = this.querySelector('[data-timer-countdown]');
      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() { window.clearInterval(this.interval); }
    tick() {
      var now = new Date();
      if (this.days.indexOf(now.getDay()) === -1 || now.getHours() < this.fromHour) { this.hidden = true; return; }
      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.cutoffHour, this.cutoffMinute, 0);
      var diff = target - now;
      if (diff <= 0) { this.hidden = true; return; }
      this.hidden = false;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (this.countdown) {
        this.countdown.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
      }
    }
  }
  if (!customElements.get('hws-shipping-timer')) customElements.define('hws-shipping-timer', HwsShippingTimer);

  /* -------------------------------------------------- delivery date
     Berekent de eerstvolgende bezorgdag: vandaag verzonden (voor de cutoff op
     een verzenddag) = morgen bezorgd; anders de eerste verzenddag erna + 1.
     Weekdag- en maandnamen komen uit Intl in de taal van de pagina. */
  class HwsDeliveryDate extends HTMLElement {
    connectedCallback() {
      var cutoffH = parseInt(this.dataset.cutoffHour, 10);
      var cutoffM = parseInt(this.dataset.cutoffMinute, 10) || 0;
      var days = (this.dataset.days || '').split(',').filter(Boolean).map(Number);
      if (!days.length) return;
      var now = new Date();
      var dispatch = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var afterCutoff = now.getHours() > cutoffH || (now.getHours() === cutoffH && now.getMinutes() >= cutoffM);
      if (afterCutoff || days.indexOf(dispatch.getDay()) === -1) {
        do { dispatch.setDate(dispatch.getDate() + 1); } while (days.indexOf(dispatch.getDay()) === -1);
      }
      var delivery = new Date(dispatch);
      delivery.setDate(delivery.getDate() + 1);
      var lang = document.documentElement.lang || 'nl';
      var formatted;
      try {
        formatted = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long' }).format(delivery);
      } catch (e) { return; }
      var parts = [this.dataset.prefix, formatted, this.dataset.suffix].filter(Boolean);
      this.textContent = parts.join(' ');
      this.hidden = false;
    }
  }
  if (!customElements.get('hws-delivery-date')) customElements.define('hws-delivery-date', HwsDeliveryDate);

  /* -------------------------------------------------- recently viewed */  /* -------------------------------------------------- recently viewed */
  function recordViewed() {
    var root = document.querySelector('[data-product-handle]');
    if (!root) return;
    var handle = root.getAttribute('data-product-handle');
    if (!handle) return;
    try {
      var list = JSON.parse(window.localStorage.getItem('hws:recently-viewed') || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      window.localStorage.setItem('hws:recently-viewed', JSON.stringify(list.slice(0, 20)));
    } catch (e) { /* storage unavailable */ }
  }

  function boot() { stickyBar(); recordViewed(); if (window.hwsDeliveryPromise) window.hwsDeliveryPromise(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (event) {
    stickyBar();
    if (window.hwsDeliveryPromise) window.hwsDeliveryPromise(event.target);
  });
})();
